import { __decorate, __metadata } from "tslib";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import store from "../../store";
import { getTenantId } from "@/store/helper";
import { IntegrationConfigurationModel } from "../models/organizationSetting/integrationConfigurations";
import { EmailSettingModel } from "../models/organizationSetting/emailSetting";
import { IOrgClockWorkRights, OrgClockWorkRightsModel } from "../models/organizationSetting/orgClockWorkRights";
let OrganizationSettingsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    let OrganizationSettingsModule = class OrganizationSettingsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "OrganizationSettings";
            this.tenantlogoUrl = "";
            this.emailSetting = null;
            this.orgClockWorkRights = null;
            this.externalApiIntegrations = [];
            this.externalApiConfiguration = null;
        }
        async UploadTenantLogo(file) {
            var url = `${getTenantId()}/${this.apiNode}/tenant-logo`;
            let { data } = await service.post(url, file);
            if (data) {
                return data;
            }
        }
        async GetOrganizationSettings(isTenantHasPermeaFeature) {
            var url = `${getTenantId()}/${this.apiNode}/settings?isTenantHasPermeaFeature=${isTenantHasPermeaFeature}`;
            let { data } = await service.get(url);
            if (data) {
                this.setTenantLogo(data.tenantLogoUrl);
                this.SetEmailSetting(data.emailSettings);
                this.SetExternalApiIntegrations(data.externalApiIntegrations);
                return data;
            }
        }
        async SaveEmailSettings(emailSetting) {
            var url = `${getTenantId()}/${this.apiNode}/save`;
            let { data } = await service.post(url, emailSetting);
            if (data) {
                this.SetEmailSetting(data.emailSettings);
                return data;
            }
        }
        async VerifyEmailSetting(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/verify/${payLoad.toEmailId}/${payLoad.organizationId}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetEmailSetting(data.emailSettings);
                return data;
            }
        }
        async SaveExternalApiConfigurations(integrationConfiguration) {
            var url = `${getTenantId()}/${this.apiNode}/providers/save`;
            let { data } = await service.post(url, integrationConfiguration);
            if (data) {
                return data;
            }
        }
        async GetZohoHRMSProviderDetails(providerId) {
            var url = `${getTenantId()}/${this.apiNode}/zohoHRMS/` + providerId;
            let { data } = await service.get(url);
            if (data) {
                this.SetIntegrationConfiguration(data.externalApiConfiguration);
                return data;
            }
        }
        async GetSelectedCalendarProvider() {
            var url = `${getTenantId()}/${this.apiNode}/calendar`;
            let { data } = await service.get(url);
            if (data) {
                this.SetIntegrationConfiguration(data.externalApiConfiguration);
                return data;
            }
        }
        async GetSelectedHRMSProvider() {
            var url = `${getTenantId()}/${this.apiNode}/hrms`;
            let { data } = await service.get(url);
            if (data) {
                this.SetIntegrationConfiguration(data.externalApiConfiguration);
                return data;
            }
        }
        async SaveCalendarConfiguration(providerId) {
            var url = `${getTenantId()}/${this.apiNode}/calendar/save/${providerId}`;
            let { data } = await service.post(url);
            if (data) {
                return data;
            }
        }
        SetEmailSetting(emailSetting) {
            this.emailSetting = emailSetting;
        }
        setTenantLogo(tenantlogo) {
            this.tenantlogoUrl = tenantlogo;
        }
        async GetOrgClockWorkRights() {
            var url = `${getTenantId()}/${this.apiNode}/clockWorkRights`;
            let { data } = await service.get(url);
            if (data) {
                this.SetOrgClockWorkRights(plainToClass(OrgClockWorkRightsModel, data.orgClockWorkRights));
                return data;
            }
        }
        SetOrgClockWorkRights(orgClockWorkRights) {
            this.orgClockWorkRights = orgClockWorkRights;
        }
        async SaveOrgClockWorkRights(users) {
            var url = `${getTenantId()}/${this.apiNode}/clockWorkRights`;
            let { data } = await service.post(url, users);
            if (data) {
                return data;
            }
        }
        SetExternalApiIntegrations(externalApiIntegrations) {
            this.externalApiIntegrations = externalApiIntegrations;
        }
        SetIntegrationConfiguration(externalApiConfiguration) {
            this.externalApiConfiguration = externalApiConfiguration;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof FormData !== "undefined" && FormData) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], OrganizationSettingsModule.prototype, "UploadTenantLogo", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], OrganizationSettingsModule.prototype, "GetOrganizationSettings", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof EmailSettingModel !== "undefined" && EmailSettingModel) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], OrganizationSettingsModule.prototype, "SaveEmailSettings", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], OrganizationSettingsModule.prototype, "VerifyEmailSetting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof IntegrationConfigurationModel !== "undefined" && IntegrationConfigurationModel) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], OrganizationSettingsModule.prototype, "SaveExternalApiConfigurations", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], OrganizationSettingsModule.prototype, "GetZohoHRMSProviderDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], OrganizationSettingsModule.prototype, "GetSelectedCalendarProvider", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], OrganizationSettingsModule.prototype, "GetSelectedHRMSProvider", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], OrganizationSettingsModule.prototype, "SaveCalendarConfiguration", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof EmailSettingModel !== "undefined" && EmailSettingModel) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], OrganizationSettingsModule.prototype, "SetEmailSetting", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], OrganizationSettingsModule.prototype, "setTenantLogo", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], OrganizationSettingsModule.prototype, "GetOrgClockWorkRights", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof IOrgClockWorkRights !== "undefined" && IOrgClockWorkRights) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], OrganizationSettingsModule.prototype, "SetOrgClockWorkRights", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], OrganizationSettingsModule.prototype, "SaveOrgClockWorkRights", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], OrganizationSettingsModule.prototype, "SetExternalApiIntegrations", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof IntegrationConfigurationModel !== "undefined" && IntegrationConfigurationModel) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], OrganizationSettingsModule.prototype, "SetIntegrationConfiguration", null);
    OrganizationSettingsModule = __decorate([
        Module({ dynamic: true, store: store, name: "OrganizationSettings", namespaced: true })
    ], OrganizationSettingsModule);
    return OrganizationSettingsModule;
})();
export const OrganizationSettings = getModule(OrganizationSettingsModule);
